import useSWR from "swr";
import { apiBaseURL } from "../../Utils/ProjectConstants";
export default function useGetWorkCenterBackground() {
  const { data, error, mutate, isLoading } = useSWR(
    `${apiBaseURL}/api/EmployeeOfTheMonth/workcenter`,
    {
      revalidateOnFocus: false,
      dedupingInterval: 300000,
    }
  );
  const backgroundUrl =
    typeof data?.data === "string" ? data.data : data?.data?.url ?? null;
  return {
    backgroundUrl,
    error,
    mutate,
    isLoading,
  };
}